<div class="auth-flex-columns">
  <div class="auth-inner-wrapper">
    <img (click)="closeDialog()" class="close-icon" src="./../../../../assets/images/icons/close.svg" alt="close-icon">
    <div class="form-block">
      <div class="heading no-description">
        <h1 class="page-title">Create new account</h1>
      </div>
      <!--
                <button class="c-button facebook w-100 mb-8-px" pButton pRipple>
            <img class="btn-icon mr-4-px" src="./../../../../assets/images/icons/facebook.svg" alt="facebook-icon">
              <span>Sign in with facebook</span>
            </button>
            <button class="c-button google w-100" pButton pRipple>
              <img class="btn-icon mr-4-px"src="./../../../../assets/images/icons/google.svg" alt="google-icon">
                <span >Sign in with Google</span>
              </button>
              <p class="or-text">Or</p>
      -->
      <form [formGroup]="registerForm">
        <app-inline-input-control [type]="'text'" [control]="registerForm.controls[RegisterFields.FirstName]"
          [label]="'First name:'" [name]="RegisterFields.FirstName"></app-inline-input-control>
        <app-inline-input-control [type]="'text'" [control]="registerForm.controls[RegisterFields.LastName]"
          [label]="'Last name:'" [name]="RegisterFields.LastName"></app-inline-input-control>
        <app-inline-input-control [type]="'email'" [control]="registerForm.controls[RegisterFields.Email]"
          [label]="'Email address:'" [name]="RegisterFields.Email"></app-inline-input-control>
        <!--
          <app-inline-input-control [type]="'password'"  [control]="registerForm.controls[RegisterFields.Password]" [label]="'Password:'" [name]="RegisterFields.Password"></app-inline-input-control>
        -->


        <button (click)="register()" [disabled]="!registerForm.valid" class="c-button secondary w-100" pButton pRipple>
          <span>Create new account</span>
          <img class="btn-icon ml-8-px" src="./../../../../assets/images/icons/arrow-right-white.svg" alt="sign-in">
        </button>

        <div class="extra-links">
          <p class="line">
            <span>By clicking this button you consent to Fastparts <a>rules</a> and <a>privacy policy</a>.</span>
          </p>
          <p class="line">
            <span>Have account ? <a (click)="openLoginDialog()">Sign in</a></span>
          </p>
        </div>
      </form>
    </div>
  </div>
  <div class="banner-container">
    <app-current-banner [minWidth]="380" [authDialogStyles]="true"></app-current-banner>
  </div>
</div>
